/**
 * Build identity of this bundle, and the release name of this deploy — the
 * ONE place that reads either.
 *
 * `build`, `gitSha`, `buildTime` are what these bytes ARE: CI passes
 * BUILD_VERSION / GIT_SHA / BUILD_TIME as docker build-args and the Dockerfile
 * exposes them as VITE_* so Vite inlines them. Nothing at deploy time can
 * change them.
 *
 * `version` is what this deploy is CALLED: the chart's appVersion, written at
 * container start into window.__RELEASE__ — the snapshot version on staging,
 * X.Y.Z once the same image is promoted to a release. It falls back to the
 * build (an image run outside the chart), then to package.json with a
 * "-local" marker (`npm run dev`), so it can never be mistaken for a deployed
 * one.
 */
import { runtimeRelease } from './utils/env';

const build = import.meta.env.VITE_APP_VERSION || `${__PKG_VERSION__}-local`;

export const buildInfo = Object.freeze({
  service: 'zehn-docs-frontend',
  version: runtimeRelease().version || build,
  build,
  gitSha: import.meta.env.VITE_GIT_SHA || 'unknown',
  buildTime: import.meta.env.VITE_BUILD_TIME || 'unknown',
  tier: runtimeRelease().tier || '',
});

/** Sentry release name: `<service>@<version>` (the release name of this deploy). */
export const sentryRelease = `${buildInfo.service}@${buildInfo.version}`;

/** "dev" for a `-dev.N.gSHA` snapshot, "release" for a bare X.Y.Z, "local" otherwise. */
export const buildKind = buildInfo.version.includes('-dev.')
  ? 'dev'
  : buildInfo.version.endsWith('-local')
    ? 'local'
    : 'release';
